import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveCajaPrimariaComponent } from '../../shared/components/SaveCajaPrimariaComponent';

export interface CreateCajaPrimariaPageProps {}

const CreateCajaPrimariaPage: React.FC<CreateCajaPrimariaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_olt);

  return <SaveCajaPrimariaComponent title="Crear Manga" />;
};

export default CreateCajaPrimariaPage;
